import { render, staticRenderFns } from "./artist.vue?vue&type=template&id=1dee364f&scoped=true&"
import script from "./artist.vue?vue&type=script&lang=ts&"
export * from "./artist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dee364f",
  null
  
)

export default component.exports